export const SubscriptionPopupMapper = (resp) => {
    var _a;
    if (resp) {
        return {
            rateBased: (_a = resp.rateBased) === null || _a === void 0 ? void 0 : _a.map((x) => ({
                schemeRefNo: x.schemeRefNo,
                date: x.date,
                brokDelivery: x.ab_DEL,
                brokIntraday: x.ab_ID,
                brokFutures: x.ab_Fut,
                brokOptions: x.ab_Opt,
                brokCurrencyFutures: x.ab_CDS,
                brokCurrencyOptions: x.ab_CDS_OPT,
                brokTotal: x.ab_Consumed,
                brokBalance: x.ab_Balance
            }))
        };
    }
    else {
        return {
            rateBased: []
        };
    }
};
